import { mergeMap, catchError, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_SUCCESS } from 'ui-components/services/notification-service';
import * as SendNotificationsApi from './send-notifications.api';
import * as Actions from './send-notifications.actions';
import { messages } from './messages';

export const sendNotificationsEpic = (action$) =>
  action$.pipe(
    ofType(Actions.SEND_NOTIFICATIONS_REQUEST),
    mergeMap(({ fulfillmentPlanIds }) => {
      NotificationService.showNotification({
        title: <FormattedMessage {...messages.sendingShipmentNotificationTitle} />,
        content: <FormattedMessage {...messages.sendingShipmentNotificationContent} />,
        notificationType: 'info',
        duration: 1000,
      });

      return SendNotificationsApi.sendNotifications(fulfillmentPlanIds).pipe(
        map((response) => Actions.sendNotificationsSuccess(response)),
        catchError((error) => of(Actions.sendNotificationsFailure(error))),
      );
    }),
  );

export const sendNotificationsError = (action$) =>
  action$.pipe(
    ofType(Actions.SEND_NOTIFICATIONS_FAILURE),
    mergeMap(() => {
      NotificationService.showNotification({
        title: <FormattedMessage {...messages.shipmentNotificationErrorTitle} />,
        content: <FormattedMessage {...messages.shipmentNotificationErrorContent} />,
        notificationType: NOTIFICATION_TYPE_ERROR,
        duration: 1000,
      });
      return EMPTY;
    }),
  );

export const sendNotificationsSuccess = (action$) =>
  action$.pipe(
    ofType(Actions.SEND_NOTIFICATIONS_SUCCESS),
    mergeMap(() => {
      NotificationService.showNotification({
        title: <FormattedMessage {...messages.shipmentNotificationSuccessTitle} />,
        content: <FormattedMessage {...messages.shipmentNotificationSuccessContent} />,
        notificationType: NOTIFICATION_TYPE_SUCCESS,
        duration: 1000,
      });
      return EMPTY;
    }),
  );

export const retryNotificationsEpic = (action$) =>
  action$.pipe(
    ofType(Actions.RETRY_NOTIFICATIONS_REQUEST),
    mergeMap(({ fulfillmentPlanIds }) =>
      SendNotificationsApi.retryNotifications(fulfillmentPlanIds).pipe(
        mergeMap(() => EMPTY),
        catchError(() => EMPTY),
      ),
    ),
  );
